// extracted by mini-css-extract-plugin
export default {"cardMedia":"_Z-z","shopText":"a0-z","videoPlayer":"b0-z","videoContainer":"c0-z"};